<!-- 优惠卡券 -->
<template>
  <div class="mine-coupon-page" v-cloak>
    <van-nav-bar left-arrow fixed title="优惠券派送" id="nav-bar" @click-left="onClickLeft"></van-nav-bar>

    <div class="list" v-if="productList.length > 0">

      <div class="item" v-for="(item, index) in productList" :key="index">
        <!-- 左边价格 -->
        <div class="left-block">
          <p class="price"><span>¥</span>{{item.coupon_value}}</p>
          <p class="limit">满{{item.min_total}}可用</p>
        </div>
        <!-- 内容 -->
        <div class="center-block">
          <p class="coupon-name">{{item.coupon_name}}</p>
          <p class="text fcolor" v-if="item.type_id != 0">·{{item.type_name}}</p>
          <p class="text fcolor" v-if="item.type_id == 0">全场通用</p>
          <p class="text gcolor" v-if="item.circulation > 0">仅剩{{item.receive_num}}/{{item.circulation}}</p>

          <p class="text gcolor" v-if="item.limit_type > 0">每人限领 <span class="fcolor"> {{item.limit_num}}</span> 张</p>

          <p class="text" v-if="item.expired_type == 1">{{item.expired_date}}后过期</p>
          <p class="text" v-if="item.expired_type == 2">自领取日起{{item.validate}}天内有效</p>
        </div>

        <!-- 右边按钮 -->
        <div class="right-block">
          <div v-if="item.is_receive == 1" class="go-btn click" @click="goUse(item)"></div>
          <div v-else class="no-btn"></div>
        </div>

        <!-- 已使用 -->
        <div class="ysy" v-if="item.status == 2"></div>
        <!-- 已过期 -->
        <div class="ygq" v-if="item.status == 3"></div>
      </div>
    </div>

    <!-- <div class="list" v-else>
         <van-divider>没有更多了~</van-divider>
       </div> -->
    <van-empty class="custom-image" v-else :image="noCoupon" />
  </div>
</template>
  
  <script type="text/babel">
import wx from "weixin-js-sdk";
export default {
  name: "MianCoupon",
  components: {},
  props: {},
  data() {
    return {
      noCoupon:require('../../assets/public/no-coupon.png'),
      pageNum: 1,
      pageSize: 10,
      productList: [
        // {
        //   coupon_id: "优惠券id",
        //   coupon_name: "名称",  //优惠券名称
        //   coupon_value: "优惠金额",//优惠金额
        //   min_total: "满足金额",
        //   circulation: "发行数量 0=无限",
        //   expired_type: "过期类型 1=绝对时间  2=相对时间领取后",
        //   expired_date: "expired_type=1有效 有效期至，包含这一天",
        //   validate: "expired_type=2有效 天数",
        //   limit_type: "0=不限制领取数量 1=限制领取数量",
        //   limit_num: "limit_type=1有效，限制的数量",
        //   receive_num: "已领取数量",
        //   is_receive: "是否可领取 1=可以",
        //   type_name: "限制使用类型名称",
        //   type_id: "限制使用类型，0=不限",
        //   message: "说明",
        // },
      ],
    };
  },
  watch: {},
  created() {},
  mounted() {
    // this.$toast.loading();
    // setTimeout(() => {
    //   this.$toast.clear();
    // }, 300);

    this.getInit();
  },
  methods: {
    getInit() {
      let _this = this;
      this.$toast.loading();
      let data = {
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/coupon_list", data, data).then((res) => {
        console.log(res.data);
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);

          let lists = res.data.data;

          if (lists && lists.length > 0) {
            //   lists = lists.map((item, index) => {
            //     return Object.assign({}, item, { checked: false });
            //   });

            console.log(lists);

            if (_this.pageNum == 1) {
              _this.productList = [];
              _this.productList = lists;
            } else {
              _this.productList = _this.productList.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            _this.finished = true; // 数据全部加载完成
          }
          _this.$toast.clear();
        } else {
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    goUse(even) {
      //   this.$toast("暂未开放~");

      let _this = this;
      let data = {
        coupon_id: even.coupon_id,
      };

      _this.$post("/api/user_receive_coupon", data, data).then((res) => {
        console.log(res.data, "底部table");
        if (res.data && res.data.code == 0) {
          _this.$toast(res.data.message);
          setTimeout(() => {
            _this.pageNum = 1;
            _this.productList = [];
            _this.getInit();
          }, 1000);

          return;
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
  },
};
</script>
  
  <style lang="scss">
.mine-coupon-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>
  
  <style lang="scss" scoped>
.fcolor {
  color: #ff5000 !important;
}
.gcolor {
  color: #39332f !important;
}
.mine-coupon-page {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;
  .list {
    padding: 0 10px;
  }
  .item {
    margin: 15px 0;
    height: 90px;
    background-color: #fff;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.06);
    // overflow: hidden;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .left-block {
      width: 120px;
      height: 100%;
      border-right: 1px dashed #eee;
      position: relative;

      display: flex;
      flex-direction: column;
      justify-content: center;
      .price {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        // line-height: 41px;
        color: #ff5000;
        letter-spacing: 1px;
        span {
          font-size: 12px;
        }
      }
      .limit {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 21px;
        color: #999999;
      }
    }
    .left-block::after {
      content: "";
      position: absolute;
      width: 10px;
      height: 10px;
      right: -5.5px;
      top: -5px;
      background: #f9f9f9;
      z-index: 2;
      border-radius: 50%;
      // box-shadow: inset 0px -5px 4px -9px;
    }
    .left-block::before {
      content: "";
      position: absolute;
      width: 10px;
      height: 10px;
      right: -5.5px;
      bottom: -5px;
      background: #f9f9f9;
      z-index: 2;
      border-radius: 50% 50% 0 0;
      // box-shadow: inset 0px 2px 5px -5px;
    }
    // 内容模块
    .center-block {
      width: 180px;
      height: 100%;
      // background-color: #eee;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .coupon-name {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        // line-height: 26px;
        color: #2a2e43;
        display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        overflow: hidden; /*超出的文本隐藏*/
        text-overflow: ellipsis; /* 溢出用省略号*/
        -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .text {
        transform: scale(0.9);
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #cccccc;
        display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        overflow: hidden; /*超出的文本隐藏*/
        text-overflow: ellipsis; /* 溢出用省略号*/
        -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
    }
    // 右模块
    .right-block {
      margin-right: 7px;
      width: 45px;
      height: 100%;
      // background-color: #eee;
      display: flex;
      align-items: center;
      // border-left: 1px dashed #eee;
      .go-btn {
        width: 100%;
        height: 100%;
        // display: inline-block;
        // padding: 6px 6px;
        // // background-color: #ff5000;
        // border-radius: 11px;
        // font-size: 10px;
        // font-family: Source Han Sans CN;
        // font-weight: 500;
        // color: #ffffff;
        // letter-spacing: 1px;

        background-image: url("../../assets/icon/ylq_a.png");
        background-repeat: no-repeat;
        background-size: 40px 40px;
        background-position: center center;
      }
      .no-btn {
        width: 100%;
        height: 100%;
        // display: inline-block;
        // padding: 6px 6px;
        // background-color: #78716d;
        // border-radius: 11px;
        // font-size: 10px;
        // font-family: Source Han Sans CN;
        // font-weight: 500;
        // color: #ffffff;
        // letter-spacing: 1px;
        background-image: url("../../assets/icon/ylq.png");
        background-repeat: no-repeat;
        background-size: 40px 40px;
        background-position: center center;
      }
    }

    // 已使用
    .ysy {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      // background-color: rgba(0, 0, 0, .1);
      background-image: url("../../assets/icon/used.png");
      background-repeat: no-repeat;
      background-size: 78px 78px;
      background-position: right 0;
    }
    // 已过期
    .ygq {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      // background-color: rgba(0, 0, 0, .1);
      background-image: url("../../assets/icon/expired.png");
      background-repeat: no-repeat;
      background-size: 156px 78px;
      background-position: center center;
    }
  }
}

.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>
  